import { useEffect } from 'react';

export const API = process.env.REACT_APP_BACKEND_URL;
export const SITE_NAME = 'CodeVoiture.fr';
export const CONTACT_EMAIL = 'contact@codevoiture.fr';
export const PUBLIC_URL = 'https://codevoiture.fr';

const PERMIS_LABELS = {
  B: 'Permis B',
  AM: 'Permis AM',
  B96: 'B96',
  BE: 'Permis BE',
  A: 'Permis A',
  A1: 'Permis A1',
  A2: 'Permis A2',
};

export function permisLabel(p) {
  return PERMIS_LABELS[p] || `Permis ${p}`;
}

export function formatDateFR(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch {
    return '';
  }
}

export function useSeoMeta({ title, description, canonicalPath, jsonLd }) {
  const jsonLdStr = JSON.stringify(jsonLd || null);
  useEffect(() => {
    if (title) document.title = title;
    if (description !== undefined) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description || '');
    }
    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', `${PUBLIC_URL}${canonicalPath}`);
    }
    const prev = document.getElementById('annuaire-jsonld');
    if (prev) prev.remove();
    if (jsonLdStr && jsonLdStr !== 'null') {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = 'annuaire-jsonld';
      script.textContent = jsonLdStr;
      document.head.appendChild(script);
    }
    return () => {
      const s = document.getElementById('annuaire-jsonld');
      if (s) s.remove();
    };
  }, [title, description, canonicalPath, jsonLdStr]);
}
